import {Avatar, message, Modal} from 'antd'
import {getId} from 'apis/model/base'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo, useState} from 'react'
import {withProps} from 'recompose'
import EntityList from 'views/AppLocals/EntityList'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {NullAsDefault, renderIf} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import getAvatar from '../../../../helpers/getAvatar'
import {FetchTeacherById} from '../components/FetchEntity'
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {renderEmptyHolder} from "../../../../components/EmptyHolder";
import {course_class_getTeacherSubjectsOfCourseClass_Api} from "../../../../apis";
import {FaLink, FaUserTie} from "react-icons/fa6";
import {GoDotFill} from "react-icons/go";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {renderIfElse, renderMail, renderPhone} from "../../../Shared";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {BsInfoCircleFill} from "react-icons/bs";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import copyToClipboard from "copy-to-clipboard";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {IoCopyOutline} from "react-icons/io5";
import {DoubleValueItem} from "../../CatholicHousehold/components/CatholicHouseholdComponents";
import {MdContactPhone} from "react-icons/md";
import {PiListNumbersBold} from "react-icons/pi";
import getAliasName from "../../../../helpers/getAliasName";
import ImageLoader from "../../../../components/ImageLoader";
import {NoImage} from "../../../../conts/imageBase64";
import LoadingBlock from "../../../LoadingBlock";


export const renderCourseClassTeacherItem =
    ({detail = true, renderActions = NullAsDefault, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
        const {teacher, subject, subjects_in_the_same = []} = item ?? {}
        const {avatar, prefix_title, teacher_idcode, fullname, contact_phone, contact_email, user, hashtags} = teacher ?? {}
        const tags = (hashtags || "").split(",").filter(e => !!e);
        const {isSm} = useContext(LayoutContext)

        return (
            <Translate key={index}>
                {(t) => (
                    <div className="p-3 flex flex-col border border-color-50 shadow-md rounded-lg hover:scale-xs custom-item-render relative">
                        <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                            <Avatar
                                size={35}
                                className="flex flex-center background-200"
                                src={avatar || getAvatar(user)}
                                icon={<FaUserTie size={19} className="text-color-500"/>}
                            />
                            <div className="flex flex-col flex-1">
                                {renderIfElse(
                                    user,
                                    <Link to={getLinkToDetail(user)} className="font-bold text-base text-color-000 no-underline leading-snug">
                                        {prefix_title && (
                                            <span className="mr-1 font-medium text-sm text-color-100 italic">{prefix_title}</span>
                                        )}
                                        {fullname}
                                    </Link>,
                                    <span className="font-medium text-base text-color-100 leading-snug">
                                        <span className="text-sm italic">{prefix_title}</span>
                                        <span className="ml-1 font-bold text-color-000">{fullname}</span>
                                    </span>
                                )}
                                <div className="flex items-center gap-6">
                                    {renderIf(
                                        teacher_idcode,
                                        <div className="text-xs text-color-500 italic">
                                            <span className="whitespace-no-wrap">
                                                {isSm ? '#' : `${t('teacher code')} : `}
                                            </span>
                                            <span
                                                onClick={() => {
                                                    copyToClipboard(teacher_idcode)
                                                    message.info(t('copied'))
                                                }}
                                                className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                            {teacher_idcode}
                                                <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                                        </div>
                                    )}
                                    {renderIf(
                                        tags.length > 0,
                                        <div className="flex gap-2">
                                            {tags.map((ee, ii) => (
                                                <span key={ii}
                                                      style={{
                                                          width: 'fit',
                                                          height: 16,
                                                          padding: '0 8px',
                                                          fontSize: 9,
                                                          borderRadius: 999
                                                      }}
                                                      className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                                {ee}
                                            </span>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="ml-3 flex flex-col">
                            {renderIf(
                                subject?.title,
                                <ItemInformation showIcon={true} label="subject taught" value={getTitle(subject) || ''}
                                                 className="text-xs italic"/>
                            )}
                            {renderIf(
                                subjects_in_the_same?.length > 0,
                                <div className="space-x-1 text-xs italic">
                                    <GoDotFill size={10} className="text-color-400"/>
                                    <span className="text-color-500">{`${t('teaching assistant for')} : `}</span>
                                    {subjects_in_the_same.map((e, i) => (
                                        <span key={i} className="font-bold text-color-100">
                                            {getTitle(e)} {i < subjects_in_the_same.length - 1 && ', '}
                                        </span>
                                    ))}
                                </div>
                            )}
                            {renderIf(
                                _.some([contact_phone, contact_email]),
                                <DoubleValueItem
                                    showIcon={true}
                                    labelFirst="contact"
                                    valueFirst={renderPhone(contact_phone)}
                                    labelSecond={contact_email && " - " || ''}
                                    valueSecond={renderMail(contact_email)}
                                    className="text-xs italic"
                                />
                            )}
                        </div>
                        <div className="text-right">
                            {renderActions(item)}
                        </div>
                    </div>
                )}
            </Translate>
        )
    }

const renderTeacherItem = ({renderActions = NullAsDefault} = {}) => (item, index) => {
    const {teacher, subject, subjects_in_the_same = []} = item ?? {}
    const {avatar, prefix_title, fullname, contact_phone, contact_email, teacher_idcode, user, hashtags} = teacher ?? {}
    const tags = (hashtags || "").split(",").filter(e => !!e);
    const {isSm} = useContext(LayoutContext)

    return (
        <Translate key={index}>
            {(t) => (
                <div className="p-3 flex flex-col border border-color-50 hover:shadow-md rounded-lg hover:scale-2xs custom-item-render relative">
                    <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                        <Avatar
                            size={35}
                            src={avatar || getAvatar(user)}
                            icon={<FaUserTie size={15} className="text-color-500"/>}
                            className="flex flex-center background-200"
                        />
                        <div className="flex flex-col flex-1">
                            {renderIfElse(
                                user,
                                <Link to={getLinkToDetail(user)}
                                      className="font-bold text-color-000 no-underline leading-snug">
                                    {prefix_title && (
                                        <span
                                            className="mr-1 font-medium text-sm text-color-100 italic">{prefix_title}</span>
                                    )}
                                    {fullname}
                                </Link>,
                                <span
                                    className="font-medium text-sm text-color-100 leading-snug">
                                        <span className="italic">{prefix_title}</span>
                                        <span className="ml-1 font-bold text-color-000">{fullname}</span>
                                    </span>
                            )}
                            <div className="flex items-center gap-6">
                                {renderIf(
                                    teacher_idcode,
                                    <div className="text-xs text-color-500 italic">
                                        <span className="whitespace-no-wrap">
                                            {isSm ? '#' : `${t('teacher code')} : `}
                                        </span>
                                        <span
                                            onClick={() => {
                                                copyToClipboard(teacher_idcode)
                                                message.info(t('copied'))
                                            }}
                                            className="font-semibold text-blue-500 hover:text-blue-700 italic cursor-pointer">
                                            {teacher_idcode}
                                            <IoCopyOutline size={12} className="ml-1"/>
                                        </span>
                                    </div>
                                )}
                                {renderIf(
                                    tags.length > 0,
                                    <div className="flex gap-2">
                                        {tags.map((ee, ii) => (
                                            <span key={ii}
                                                  style={{
                                                      width: 'fit',
                                                      height: 16,
                                                      padding: '0 8px',
                                                      fontSize: 9,
                                                      borderRadius: 999
                                                  }}
                                                  className="flex flex-center border border-primary-300 font-medium text-primary-500 italic leading-tight">
                                                {ee}
                                            </span>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="ml-3 flex flex-col">
                        <ItemInformation showIcon={true} label="subject taught" value={subject?.title}
                                         className="text-xs italic"/>
                        {renderIf(
                            subjects_in_the_same?.length > 0,
                            <div className="space-x-1 text-xs italic">
                                <GoDotFill size={10} className="text-color-400"/>
                                <span className="text-color-500">
                                {`${t('teaching assistant for')} : `}
                            </span>
                                {subjects_in_the_same.map((e, i) => (
                                    <span key={i} className="font-bold text-color-100">
                                  {getTitle(e)} {i < subjects_in_the_same?.length - 1 && ', '}
                                </span>
                                ))}
                            </div>
                        )}
                        {renderIf(
                            _.some([contact_phone, contact_email]),
                            <DoubleValueItem
                                showIcon={true}
                                labelFirst="contact"
                                valueFirst={renderPhone(contact_phone)}
                                labelSecond={contact_email && " - " || ''}
                                valueSecond={renderMail(contact_email)}
                                className="text-xs italic"
                            />
                        )}
                    </div>
                    <div className="text-right">
                        {renderActions(item)}
                    </div>
                </div>
            )}
        </Translate>
    )
}

const DetailModalContent = ({item, course_class, onCancel = NullAsDefault}) => {
    const t = useTranslate()
    const {isSm} = useContext(LayoutContext)
    const {edit} = course_class ?? {}
    const {
        avatar,
        user,
        prefix_title,
        teacher_idcode,
        fullname,
        gender,
        date_of_birth,
        place_of_birth,
        contact_phone,
        contact_email,
        contact_address,
        majors,
        degrees,
        experiences,
        fields,
        hashtags,
    } = item ?? {}

    const tags = (hashtags || "").split(",").filter(e => !!e);


    return (
        <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
                <HeaderWithIconLine
                    icon={<BsInfoCircleFill size={14} className="text-color-500 mr-1"/>}
                    title="teacher information"
                    className="text-sm text-color-400"
                />
                <div className="flex gap-3">
                    <ImageLoader
                        style={{width: isSm ? 100 : 130, height: isSm ? 100 : 130}}
                        src={avatar || getAvatar(user) || NoImage}
                        fallback={NoImage}
                        className="background-200 rounded-lg object-cover mt-1"
                    />
                    <div className="flex flex-col flex-1 gap-1">
                        <ItemInformation primary={true} showIcon={true} label={!isSm && "full name"}
                                         value={`${prefix_title || ''} ${fullname}`} className="text-sm"/>
                        <ItemInformation showIcon={true} label="teacher code" value={`#${teacher_idcode}`}
                                         className="text-xs italic"/>
                        {renderIf(
                            gender !== 0,
                            <ItemInformation showIcon={true} label={!isSm && "gender"}
                                             value={t(getLabelOfGender(gender))} className="text-xs italic"/>
                        )}
                        {renderIf(
                            tags.length,
                            <div className="flex items-center gap-2 mt-2">
                                {tags.map((ee, ii) => (
                                    <span
                                        key={ii}
                                        style={{padding: '2px 8px'}}
                                        className="rounded-full border border-primary-300 font-medium text-2xs text-primary-300 italic leading-tight">
                                  {ee}
                                </span>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {renderIf(
                user,
                <div className="flex flex-col gap-1">
                    <span className="text-xs text-color-500 italic">
                      <FaLink size={10} className="mr-1 text-color-400"/>
                        {`${t('link account')} : `}
                    </span>
                    <div className="ml-2 flex items-center gap-3">
                        <Avatar
                            size={36}
                            src={getAvatar(user)}
                            icon={<FaUserTie size={18} className="text-color-500"/>}
                            className="flex flex-center background-200"
                        />
                        <div className="flex flex-col">
                    <span className="text-xs text-color-500 italic leading-tight">
                        {`${t('account name')} : `}
                    </span>
                            {renderIfElse(
                                edit === true,
                                <Link target="_blank" to={getLinkToDetail(user)}
                                      className="font-medium text-primary-700 no-underline leading-snug">
                                    {getAliasName(user, 'patron_saint')}
                                    {` ${getTitle(user)}`}
                                </Link>,
                                <span className="font-medium text-primary-700 leading-snug">
                          {getAliasName(user, 'patron_saint')}
                                    {getTitle(user)}
                        </span>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {renderIf(
                edit,
                <div className="flex flex-col gap-1">
                    <HeaderWithIconLine
                        icon={<MdContactPhone size={14} className="text-color-500 mr-1"/>}
                        title="contact information"
                        className="text-sm text-color-400"
                    />
                    <div className="ml-0 md:ml-1 flex flex-col gap-1">
                        <ItemInformation showIcon={true} label="phone" value={contact_phone}
                                         className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="email" value={contact_email}
                                         className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="address" value={contact_address}
                                         className="text-xs italic"/>
                    </div>
                </div>
            )}
            {renderIf(
                _.some([majors, degrees, experiences, fields]),
                <div className="flex flex-col gap-1">
                    <HeaderWithIconLine
                        icon={<PiListNumbersBold size={14} className="text-color-500 mr-1"/>}
                        title="education level"
                        className="text-sm text-color-400"
                    />
                    <div className="ml-0 md:ml-1 flex flex-col gap-1">
                        <ItemInformation showIcon={true} label="majors" value={majors} className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="degrees" value={degrees} className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="experiences" value={experiences}
                                         className="text-xs italic"/>
                        <ItemInformation showIcon={true} label="fields" value={fields} className="text-xs italic"/>
                    </div>
                </div>
            )}
            <div className="flex justify-end p-3 mt-3">
                <span onClick={onCancel} className="font-medium text-color-200 hover:text-color-000 cursor-pointer">
                    {t('close')}
                </span>
            </div>
        </div>
    )
}

const CourseClassTeachers = ({
                                 item,
                                 renderList,
                                 detail = false,
                                 ...props
                             }) => {
    const t = useTranslate()

    const {edit} = item ?? {}

    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    const course_class_id = getId(item)

    const apiInfo = course_class_getTeacherSubjectsOfCourseClass_Api

    const refreshKey = useMemo(
        () => [apiInfo.path.replace(':id', course_class_id)].join('/'),
        [course_class_id]
    )

    const onCancel = () => {
        setAction({})
    }

    const modal = useMemo(() => {
        const {teacher} = action?.value ?? {}
        const id = getId(teacher)
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({item: {}})
        let params = {}
        let modal_params = {}
        switch (action?.type) {
            case CRUD.READ:
                modal_params = {
                    width: 600,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('teacher')}
                        </div>
                    ),
                }
                params = {
                    course_class: item,
                    onCancel: () => {
                        onCancel()
                    }
                }
                Content = DetailModalContent
                Wrapper = withProps({id})(FetchTeacherById)
                break
            default:
                break
        }
        return (
            <Modal
                footer={null}
                onCancel={onCancel}
                destroyOnHidden={true}
                open={action?.type}
                className="custom-modal"
                {...modal_params}>
                <Wrapper>
                    {({item, isLoading}) => {
                        if (!!isLoading) {
                            return <LoadingBlock/>
                        }
                        return (
                            <Content
                                {...params}
                                {...{item, onCancel}}
                            />
                        )
                    }}
                </Wrapper>
            </Modal>
        )
    }, [item, action])

    const renderActions = useCallback(
        (item) =>
            renderIf(
                edit,
                <div
                    onClick={() => {
                        setAction({type: CRUD.READ, value: item})
                    }}
                    className="text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                    {`${t('view detail')}...`}
                </div>
            ),
        [edit]
    )

    const {class_subjects = [], number_of_students, course, course_class_idcode, title} = item ?? {}

    return (
        <React.Fragment>
            {_.isFunction(renderList) ? (
                renderList({
                    edit,
                    action,
                    detail,
                    renderItem: renderTeacherItem({
                        renderActions,
                    }),
                })
            ) : (
                <EntityList
                    key={refreshKey}
                    apiInfo={apiInfo}
                    refreshKey={refreshKey}
                    RenderEntity={React.Fragment}
                    query={bindQueryParam({id: course_class_id})}
                    renderEmpty={renderEmptyHolder}
                    renderItem={renderCourseClassTeacherItem({
                        detail,
                        renderActions,
                    })}
                    renderWrap={(child, __, count) => (
                        <div className="flex flex-col items-start space-y-6">
                            <div className="w-full flex flex-col gap-1">
                                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('class information')}
                                </div>
                                <div className="ml-2 flex flex-col gap-1">
                                    <ItemInformation
                                        showIcon={true}
                                        label="course class idcode"
                                        value={course_class_idcode}
                                        className="text-xs italic"
                                    />
                                    <ItemInformation
                                        showIcon={true}
                                        label="belong to the course"
                                        value={getTitle(course)}
                                        className="text-xs italic"
                                    />
                                    <ItemInformation
                                        showIcon={true}
                                        label="number of student"
                                        value={`${number_of_students || 0} ${t('students')}`}
                                        className="text-xs italic"
                                    />
                                    {renderIf(
                                        class_subjects.length > 0,
                                        <span className="space-x-1 text-xs italic">
                            <GoDotFill size={10} className="text-color-400"/>
                            <span className="text-color-500">{`${t('subjects')} : `}</span>
                                            {class_subjects.map((e, i) => (
                                                <span key={i} className="font-semibold text-color-100">
                                    {e?.subject?.title} {i < class_subjects.length - 1 && ', '}
                                </span>
                                            ))}
                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="w-full flex flex-col gap-3 flex-1">
                                <div className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                    {t('list teachers of class')}
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    {child}
                                </div>
                            </div>
                        </div>
                    )}
                    {...props}
                />
            )}
            {modal}
        </React.Fragment>
    )
}

export default CourseClassTeachers
